(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.U4Setup = factory();
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const jobs = {
    front: ['spotlights', 'led-bar'],
    fog: ['fog-lights'],
    work: ['working-lights'],
    camp: ['camping-lights'],
    rock: ['rock-lights']
  };
  const text = (value, length) => typeof value === 'string' ? value.trim().slice(0, length || 100) : '';
  const choice = (value, options, fallback) => options.includes(value) ? value : fallback;
  const clean = (input) => {
    const source = input && typeof input === 'object' ? input : {};
    const amount = (key, maximum) => {
      const value = text(String(source[key] === undefined ? '' : source[key]), 12);
      return value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= maximum ? value : '';
    };
    const result = {
      job: choice(source.job, Object.keys(jobs), ''),
      family: choice(source.family, ['any', 'round', 'bar'], 'any'),
      vehicle_known: choice(source.vehicle_known, ['yes', 'unknown'], 'unknown'),
      make: text(source.make, 60), model: text(source.model, 60), year: text(source.year, 4),
      mount: text(source.mount, 40),
      measured: choice(source.measured, ['yes', 'unknown'], 'unknown'),
      width: amount('width', 5000), height: amount('height', 5000),
      length: choice(source.length, ['any', '300 mm', '600 mm', '900 mm'], 'any'),
      budget: amount('budget', 1000000),
      priority: choice(source.priority, ['price', 'harness'], 'price'),
      voltage: choice(source.voltage, ['12V', '24V', 'unknown'], 'unknown'),
      installation: choice(source.installation, ['installer', 'guidance'], 'guidance'),
      parts: Array.isArray(source.parts) ? source.parts.filter(value => ['harness', 'mounts', 'switch'].includes(value)).slice(0, 3) : []
    };
    if (result.vehicle_known === 'unknown') result.make = result.model = result.year = '';
    if (result.measured === 'unknown') result.width = result.height = '';
    if (result.job !== 'camp') result.length = 'any';
    if (result.job !== 'front') result.family = 'any';
    return result;
  };
  const evaluate = (products, input, mapping) => {
    const answers = clean(input);
    const routes = mapping && typeof mapping === 'object' ? mapping : jobs;
    let collections = routes[answers.job] || [];
    if (answers.job === 'front' && answers.family === 'round') collections = (routes.front || jobs.front).slice(0, 1);
    if (answers.job === 'front' && answers.family === 'bar') collections = (routes.front || jobs.front).slice(1, 2);
    const pool = (Array.isArray(products) ? products : []).filter(product => Array.isArray(product.collections) && product.collections.some(handle => collections.includes(handle)));
    const budget = answers.budget === '' ? Infinity : Math.round(Number(answers.budget) * 100);
    let unavailable = 0, overBudget = 0, differentLength = 0;
    const candidates = [];
    pool.forEach(product => {
      const available = (product.variants || []).filter(variant => variant.available && Number.isFinite(variant.price));
      if (!available.length) { unavailable += 1; return; }
      if (answers.job === 'camp' && answers.length !== 'any' && product.size !== answers.length) { differentLength += 1; return; }
      const eligible = available.filter(variant => variant.price <= budget);
      if (!eligible.length) { overBudget += 1; return; }
      const variant = eligible[0];
      const reasons = ['job', 'available'];
      if (answers.budget !== '') reasons.push('budget');
      if (answers.job === 'camp' && answers.length !== 'any') reasons.push('length');
      if (answers.family !== 'any') reasons.push('family');
      if (answers.priority === 'harness' && product.harness === true) reasons.push('harness');
      candidates.push({ product, variant, reasons });
    });
    candidates.sort((a, b) => {
      if (answers.priority === 'harness' && (a.product.harness === true) !== (b.product.harness === true)) return a.product.harness === true ? -1 : 1;
      return a.variant.price - b.variant.price || String(a.product.id).localeCompare(String(b.product.id));
    });
    return { answers, results: candidates.slice(0, 3), eligibleCount: candidates.length, poolCount: pool.length, excluded: { unavailable, overBudget, differentLength }, fitmentConfirmed: false, budget };
  };
  return { clean, evaluate, jobs };
});
